import { createApp } from 'vue'

import App from './App.vue'
import pinia from '@/state/pinia'
import router from './router'

import VueApexCharts from 'vue3-apexcharts'
import vClickOutside from 'click-outside-vue3'
import { registerScrollSpy } from 'vue3-scroll-spy'

import { vMaska } from 'maska'
import i18n from './i18n'
import { initFirebaseBackend } from './authUtils'
import { configureFakeBackend } from './helpers/fake-backend'

import BootstrapVueNext from 'bootstrap-vue-next'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import '@/assets/scss/app.scss'
import '@vueform/multiselect/themes/default.css'

type FirebaseConfig = {
  apiKey?: string
  authDomain?: string
  databaseURL?: string
  projectId?: string
  storageBucket?: string
  messagingSenderId?: string
  appId?: string
  measurementId?: string
}

const env = process.env as Record<string, string | undefined>

const firebaseConfig: FirebaseConfig = {
  apiKey: env.VUE_APP_APIKEY,
  authDomain: env.VUE_APP_AUTHDOMAIN,
  databaseURL: env.VUE_APP_VUE_APP_DATABASEURL,
  projectId: env.VUE_APP_PROJECTId,
  storageBucket: env.VUE_APP_STORAGEBUCKET,
  messagingSenderId: env.VUE_APP_MESSAGINGSENDERID,
  appId: env.VUE_APP_APPId,
  measurementId: env.VUE_APP_MEASUREMENTID,
}

if (env.VUE_APP_DEFAULT_AUTH === 'firebase') {
  // The Firebase backend initializer expects the config object; typing as any to avoid
  // external types dependency issues in strict mode.
  (initFirebaseBackend as unknown as (cfg: any) => void)(firebaseConfig as any)
} else {
  configureFakeBackend()
}

import 'sweetalert2/dist/sweetalert2.min.css'

// vue-chartist doesn't ship TypeScript types; use require with an explicit any type.
// eslint-disable-next-line @typescript-eslint/no-var-requires
const VueChartist: any = require('vue-chartist')


const app = createApp(App)
  .use(pinia)
  .use(router)
  .use(VueChartist)
  .use(BootstrapVueNext)
  .use(VueApexCharts)
  .use(vClickOutside)
  .use(i18n)
  .use(registerScrollSpy)
  .directive('maska', vMaska)

app.config.errorHandler = (err, instance, info) => {
    console.group("%c [Vue Error Handler]", "color: red; font-weight: bold;");
    console.log("Błąd:", err); // Tu zobaczysz np. "Cannot read property 'key' of undefined"
    console.log("Info:", info);
    console.log("Komponent:", instance);
    console.groupEnd();
};

app.mount('#app')
